/* ============================================================
   DHAAGA TRIBE — Swipeable Product Card Gallery
   Delegated pointer/click handling for [data-swipe-media]
   containers: the collection grid's ".pc" cards and the
   featured-strip ".product-card" cards both use it.
   ============================================================ */
(function () {
  var DRAG_THRESHOLD = 6;      // px of movement before a tap counts as a drag
  var SWIPE_FRACTION = 0.18;   // fraction of card width needed to advance a slide
  var drag = null;

  function track(media) { return media.querySelector('[data-swipe-track]'); }
  function count(media) { var t = track(media); return t ? t.children.length : 0; }
  function index(media) { return parseInt(media.dataset.swipeIndex || '0', 10); }

  function setIndex(media, i, skipAnim) {
    var t = track(media);
    var n = count(media);
    if (!t || n < 2) return;
    i = Math.max(0, Math.min(i, n - 1));
    media.dataset.swipeIndex = i;
    // Drives the desktop arrows: hide "prev" on the first photo, "next" on the last.
    media.classList.toggle('has-prev', i > 0);
    media.classList.toggle('at-end', i >= n - 1);
    t.style.transition = skipAnim ? 'none' : '';
    t.style.transform = 'translateX(-' + (i * 100) + '%)';
    if (skipAnim) {
      void t.offsetHeight; // force reflow so the next call re-enables the transition
      t.style.transition = '';
    }
  }

  document.addEventListener('pointerdown', function (e) {
    var media = e.target.closest('[data-swipe-media]');
    if (!media || count(media) < 2) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    drag = {
      media: media,
      startX: e.clientX,
      startY: e.clientY,
      dx: 0,
      width: media.getBoundingClientRect().width,
      index: index(media),
      moved: false,
      locked: null,
      pointerId: e.pointerId
    };
  }, { passive: true });

  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.pointerId) return;
    var dx = e.clientX - drag.startX;
    var dy = e.clientY - drag.startY;
    if (drag.locked === null) {
      if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
      drag.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    }
    if (drag.locked !== 'x') return;
    drag.moved = true;
    drag.dx = dx;
    var t = track(drag.media);
    var n = count(drag.media);
    var percent = (dx / drag.width) * 100;
    if ((drag.index === 0 && dx > 0) || (drag.index === n - 1 && dx < 0)) percent *= 0.35;
    t.style.transition = 'none';
    t.style.transform = 'translateX(calc(-' + (drag.index * 100) + '% + ' + percent + '%))';
  }, { passive: true });

  function endDrag() {
    if (!drag) return;
    var media = drag.media, dx = drag.dx, width = drag.width, i = drag.index;
    if (drag.locked === 'x' && drag.moved) {
      var next = i;
      if (Math.abs(dx) > width * SWIPE_FRACTION) next = dx < 0 ? i + 1 : i - 1;
      setIndex(media, next);
      media._swipeJustDragged = true;
      setTimeout(function () { media._swipeJustDragged = false; }, 60);
    }
    drag = null;
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  // Tap zones — left/right edge of the image steps one slide at a time.
  document.addEventListener('click', function (e) {
    var zonePrev = e.target.closest('[data-swipe-prev]');
    var zoneNext = e.target.closest('[data-swipe-next]');
    if (!zonePrev && !zoneNext) return;
    var media = e.target.closest('[data-swipe-media]');
    if (!media) return;
    e.preventDefault();
    e.stopPropagation();
    if (media._swipeJustDragged) return; // the drag already moved the slide
    setIndex(media, index(media) + (zoneNext ? 1 : -1));
  }, true);

  // A real drag just happened — swallow the click so the card's own link
  // doesn't also navigate to the product page.
  document.addEventListener('click', function (e) {
    var media = e.target.closest('[data-swipe-media]');
    if (!media || !media._swipeJustDragged) return;
    var link = e.target.closest('a');
    if (link) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  // === FIRST-PRODUCT "PEEK" HINT ===
  // Nothing on the card hints that it's swipeable. Rather than every card
  // doing this as it scrolls into view (looked like a glitch repeating down
  // the page), only the very first product tile on the page peeks once — enough
  // to teach the pattern without it feeling like a bug. This is a brief
  // instructional cue rather than decorative motion, so unlike the GSAP parallax
  // elsewhere it still runs under prefers-reduced-motion (many phones report
  // that as true simply from Low Power Mode). Any real interaction (drag or
  // tap) cancels it.
  // It waits until (1) the page loader has faded away and (2) that first card is
  // actually on screen, so the hint is never played behind the loader or
  // off-screen where nobody sees it.
  var firstMedia = document.querySelector('[data-swipe-media]');
  if (firstMedia && count(firstMedia) > 1) {
    var peeked = false;

    var busy = function () {
      return firstMedia.dataset.swipeIndex || (drag && drag.media === firstMedia);
    };

    var peek = function () {
      if (peeked) return;
      peeked = true;
      setTimeout(function () {
        if (busy()) return;
        var t = track(firstMedia);
        t.style.transition = 'transform 0.5s cubic-bezier(0.3, 0, 0.2, 1)';
        t.style.transform = 'translateX(-16%)';
        setTimeout(function () {
          if (busy()) return;
          t.style.transition = 'transform 0.85s cubic-bezier(0.45, 0, 0.2, 1)';
          t.style.transform = 'translateX(0%)';
        }, 550);
      }, 250);
    };

    var whenVisible = function () {
      if (!('IntersectionObserver' in window)) { peek(); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); peek(); }
      }, { threshold: 0.6 });
      io.observe(firstMedia);
    };

    var pre = document.getElementById('dt-preloader');
    var loaderGone = !pre || pre.classList.contains('dt-preloader--hide') || getComputedStyle(pre).visibility === 'hidden';
    if (loaderGone) {
      setTimeout(whenVisible, 300);
    } else {
      var started = false;
      var go = function () { if (started) return; started = true; setTimeout(whenVisible, 550); };
      var mo = new MutationObserver(function () {
        if (pre.classList.contains('dt-preloader--hide')) { mo.disconnect(); go(); }
      });
      mo.observe(pre, { attributes: true, attributeFilter: ['class'] });
      setTimeout(function () { mo.disconnect(); go(); }, 8000); // safety: never skip the hint entirely
    }
  }
})();
